import { AxiosPost, AxiosGet } from "../AxiosWrapper";
import { DOCUMENTSTORE_SERVICE_URL } from "../../constants/ServiceUrls";

export const uploadDocumentsToClientBucket = (formData, config = {}) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/Document/UploadDocumentsToClientBucket`,
    formData,
    config
  );
};

export const uploadCustomerMetadataToClientBucket = (formData) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/Document/UploadCustomerMetadataToClientBucket`,
    formData
  );
};

export const bulkFolderUpload = (formData) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/Document/BulkFolderUpload`,
    formData
  );
};

export const deleteDocumentByDocumentId = (
  documentIdentifiers,
  reasonIds,
  cb
) => {
  return AxiosPost(`${DOCUMENTSTORE_SERVICE_URL}api/Document/DeleteDocuments`, {
    documentIdentifiers,
    reasonIds,
  });
};
export const getUploadHistory = (cb) => {
  return AxiosPost(`${DOCUMENTSTORE_SERVICE_URL}api/Document/GetUploadHistory`);
};

export const getSupportedContentTypes = () => {
  return AxiosGet(
    `${DOCUMENTSTORE_SERVICE_URL}api/Document/GetSupportedContentTypes`
  );
};

export const getSupportedFileExtensions = () => {
  return AxiosGet(
    `${DOCUMENTSTORE_SERVICE_URL}api/Document/GetSupportedFileExtensions`
  );
};
export const moveDocuments = (moveDocumentParameters) => {
  return AxiosPost(`${DOCUMENTSTORE_SERVICE_URL}api/Document/MoveDocuments`, {
    ...moveDocumentParameters,
  });
};

export const getDocumentsReadyForRetentionMarking = (
  getDocumentsReadyForRetentionMarkingParameters
) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/Document/GetDocumentsReadyForRetentionMarking`,
    getDocumentsReadyForRetentionMarkingParameters
  );
};

export const getDocumentsMarkedForPermanentStorage = (
  getDocumentsMarkedForPermanentStorageParameters
) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/Document/GetDocumentsMarkedForPermanentStorage`,
    getDocumentsMarkedForPermanentStorageParameters
  );
};

export const getDocumentsMarkedForPermanentDestruction = (
  getDocumentsMarkedForPermanentDestructionParameters
) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/Document/GetDocumentsMarkedForPermanentDestruction`,
    getDocumentsMarkedForPermanentDestructionParameters
  );
};

export const getDocumentsInRecycleBin = (
  getDocumentsInRecycleBinParameters
) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/Document/GetDocumentsInRecycleBin`,
    getDocumentsInRecycleBinParameters
  );
};

export const markDocumentsForDestruction = (
  markDocumentsForDestructionParameters
) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/Document/MarkDocumentsForPermanentDestruction`,
    markDocumentsForDestructionParameters
  );
};

export const markDocumentsForPermanentStorage = (
  markDocumentsForPermanentStorageParameters
) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/Document/MarkDocumentsForPermanentStorage`,
    markDocumentsForPermanentStorageParameters
  );
};

export const restoreDocuments = (restoreDocumentParameters) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/Document/RestoreDocuments`,
    restoreDocumentParameters
  );
};

export const permanentlyDeleteDocuments = (
  permanentlyDeleteDocumentsParameters
) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/Document/PermanentlyDeleteDocuments`,
    permanentlyDeleteDocumentsParameters
  );
};

export const reviveDocumentsToDefaultRetentionState = (
  restoreMarkedDocumentsToReviewParameters
) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/Document/ReviveDocumentsToDefaultRetentionState`,
    restoreMarkedDocumentsToReviewParameters
  );
};

export const extendDocumentRetentionPeriod = (
  DocumentIdentifier,
  DeferralDate
) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/Document/ExtendDocumentRetentionPeriod`,
    { DocumentIdentifier, DeferralDate }
  );
};

export default {
  uploadDocumentsToClientBucket,
  uploadCustomerMetadataToClientBucket,
  bulkFolderUpload,
  deleteDocumentByDocumentId,
  getUploadHistory,
  getSupportedContentTypes,
  getSupportedFileExtensions,
  moveDocuments,
  getDocumentsReadyForRetentionMarking,
  getDocumentsMarkedForPermanentStorage,
  getDocumentsMarkedForPermanentDestruction,
  getDocumentsInRecycleBin,
  markDocumentsForDestruction,
  markDocumentsForPermanentStorage,
  restoreDocuments,
  permanentlyDeleteDocuments,
  reviveDocumentsToDefaultRetentionState,
  extendDocumentRetentionPeriod,
};
